import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {IndependenceStatus, HttpStatusCodes, validationTypes} from '../../util/uiconstants';
import _ from 'lodash';
import {isApiResponseOk} from '../../util/utils';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function engagementReducer(state = initialState.engagement, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT: {
			return action.response;
		}
		//TODO: PATCH call will return another object. Id needed to add a new state?
		case types.UPDATE_ENGAGEMENT: {
			return state;
		}
		case types.UNLINK_ENGAGEMENT_GROUP: {
			return state;
		}
		case types.GET_ALL_ENGAGEMENTS: {
			if (isApiResponseOk(action)) {
				return {
					...state,
					allEngagements: action.response
				};
			}
			return state;
		}
		default:
			return state;
	}
}

export function engagementMetaDataReducer(state = initialState.engagementMetaData, action) {
	switch (action.type) {
		case types.LOAD_ENGAGEMENTMETADATA:
			return action.response.engagementmetadatadetails || state;
		default:
			return state;
	}
}

export function engagementUsersWithRoles(state = initialState.engagementUsersWithRoles, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_USERS_WITHROLES: {
			if (state && state.selectedItem && state.selectedItem.reviewNoteSummaryCallInitiated) {
				action.response.selectedItem = state.selectedItem;
			}
			return action.response;
		}
		case types.SELECT_ENGAGEMENT_USERROLE_ITEM: {
			return Object.assign({}, state, {
				selectedItem: action.payload
			});
		}
		default:
			return state;
	}
}

export function engagementIndependenceUsersReducer(state = initialState.independenceConfirmation, action) {
	switch (action.type) {
		case types.GET_ENGAGMENT_USER_INDEPENDENCE: {
			const tableList = action.response.users.map((x) => {
				return {
					userId: x.userId,
					fullName: `${x.firstName} ${x.lastName}`,
					confirmationDate:
						x.independenceStatusId === IndependenceStatus.Incomplete
							? ''
							: x.independenceStatusId === IndependenceStatus.NotApplicable
							? 'Not Applicable'
							: x.independenceStatusModifyDate,
					//TODO: return from backend
					confirmationStatus: Object.keys(IndependenceStatus).find(
						(k) => IndependenceStatus[k] === x.independenceStatusId
					),
					independenceStatusId: x.independenceStatusId,
					independenceStatusModifyUserName: x.independenceStatusModifyUserName,
					validations: [],
					validationCount: 0,
					independenceIndividualDocumentId: x.independenceIndividualDocumentId
				};
			});
			return Object.assign({}, state, {
				list: tableList
			});
		}
		case types.CLEAN_ENGAGMENT_USER_INDEPENDENCE: {
			return {};
		}
		case types.GET_INDEPENDENCE_VALIDATIONS: {
			let newState = _.cloneDeep(state);
			if (newState.list !== undefined) {
				// Get validations.
				let validations = [];
				action.response.map((validationType) => {
					if (validationType.children.length > 0) {
						validationType.children.map((item) => {
							validations.push({
								userId: item.validationId.toLowerCase(),
								validationTypeId: item.validationTypeId
							});
						});
					}
				});

				// If there are validations, modify the state to update validations properties on users
				if (validations.length > 0) {
					validations.map((item) => {
						let user = newState.list.find((x) => {
							return x.userId === item.userId;
						});
						if (user) {
							user.validations.push(item.validationTypeId);
							user.validationCount++;
							return Object.assign(newState.list, user);
						}
						return;
					});
				}
				return Object.assign({}, state, newState);
			}
			return state;
		}
		case types.CREATE_INDEPENDENCE_FORM:
		case types.REMOVE_INDEPENDENCE_OVERRIDE: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				return updateIndependenceUserData(state, action);
			}
			return state;
		}
		case types.REMOVE_INDEPENDENCE_TEAM_MEMBER: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let newState = _.cloneDeep(state);
				newState.list = newState.list.filter((item) => item.userId !== action.userId);
				return newState;
			}
			return state;
		}

		default:
			return state;
	}
}

function updateIndependenceUserData(state, action) {
	let newState = _.cloneDeep(state);
	//Looking for the selected user.
	let user = newState.list.find((item) => item.userId === action.userId);

	if (user) {
		switch (action.type) {
			case types.CREATE_INDEPENDENCE_FORM:
				{
					//Adding the document id of the created form.
					user.independenceIndividualDocumentId = action.response;
				}
				break;
			case types.REMOVE_INDEPENDENCE_OVERRIDE:
				{
					user.independenceStatusId = IndependenceStatus.Incomplete;
					user.confirmationStatus = Object.keys(IndependenceStatus).find(
						(k) => IndependenceStatus[k] === IndependenceStatus.Incomplete
					);
					user.independenceStatusModifyUserName = action.modifyUserName;
					user.validations = [validationTypes.IndependenceCompliance]; //validation type for incomplete form
					user.confirmationDate = '';
				}
				break;
			default: {
				return state;
			}
		}
	}

	return newState;
}

export function engagementAccessLocationReducer(state = initialState.hasAccessLocation, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_IPFILTERSTATUS: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		}
		default:
			return state;
	}
}
